import { useParams } from 'quartz-routing/react-router';
export function useTicketDetailsParams() {
  const {
    ticketId,
    threadId
  } = useParams();
  return {
    ticketId: Number(ticketId),
    threadId: threadId !== undefined ? Number(threadId) : undefined
  };
}